import { getMeterColorByPercentage } from '@web/constants';

export const DEFAULT_CHART_COLORS = [
  'var(--nn-color-primary-accent-light)',
  'var(--nn-accent-green)',
  'var(--nn-accent-blue)',
  'var(--nn-accent-red)',
  'var(--nn-accent-orange)',
] as const;

export const DEFAULT_CHART_HOVER_COLORS = [
  'var(--nn-color-primary-accent)',
  'var(--nn-hover-accent-green)',
  'var(--nn-hover-accent-blue)',
  'var(--nn-hover-accent-red)',
  'var(--nn-hover-accent-orange)',
] as const;

export const getChartColorByPercentage = (percentage: number) =>
  getMeterColorByPercentage(percentage);
